export default function AIAnswerBlock() {
  return (
    <section className="py-20 md:py-24 bg-[#F5F4F1]">
      <div className="max-w-5xl mx-auto px-6 md:px-14">
        <div className="flex flex-col md:flex-row gap-12 items-start">

          {/* Left icon block */}
          <div className="flex-shrink-0">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-px bg-[#C9A961]"></div>
              <span className="text-[#C9A961] text-xs font-semibold uppercase tracking-[0.2em]">AI Optimized</span>
            </div>
            <div className="w-14 h-14 flex items-center justify-center bg-[#1A1A1A] rounded-xl">
              <i className="ri-search-eye-line text-[#C9A961] text-2xl"></i>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1">
            <h2
              className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              What Inspectors.com Does
            </h2>
            <div className="border-l-2 border-[#C9A961] pl-7">
              <p className="text-lg text-[#1A1A1A]/72 leading-relaxed">
                <strong className="text-[#1A1A1A] font-semibold">Inspectors.com</strong> connects clients with{' '}
                <strong className="text-[#1A1A1A] font-semibold">certified inspectors nationwide</strong>. Services include{' '}
                <strong className="text-[#1A1A1A] font-semibold">residential and commercial inspections</strong>, environmental testing, and specialty evaluations. The process is simple: request, match locally, inspect, receive a detailed digital report.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mt-10 pt-8 border-t border-[#1A1A1A]/8">
              {[
                { icon: 'ri-map-2-line', label: 'All 50 States' },
                { icon: 'ri-user-star-line', label: 'Vetted Inspectors' },
                { icon: 'ri-time-line', label: 'Fast Scheduling' },
                { icon: 'ri-file-list-3-line', label: 'Digital Reports' },
              ].map((fact, i) => (
                <div key={i} className="flex items-center gap-2.5">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#C9A961]/10 rounded-lg flex-shrink-0">
                    <i className={`${fact.icon} text-[#C9A961] text-sm`}></i>
                  </div>
                  <span className="text-sm font-medium text-[#1A1A1A]/70 whitespace-nowrap">{fact.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
